module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_9006.2d05b18d.png";